import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    Input,
    Link,
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    createTableColumn,
    makeStyles,
    shorthands,
} from "@fluentui/react-components";
import { SearchRegular } from "@fluentui/react-icons";
import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context";

import {
    DataGridBody,
    DataGrid,
    DataGridRow,
    DataGridHeader,
    DataGridCell,
    DataGridHeaderCell,
    RowRenderer,
} from "@fluentui-contrib/react-data-grid-react-window";
// import { buildFilter, idRecord } from "../../db_utils"; // Not needed for API client

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        ...shorthands.flex(1),
        ...shorthands.padding("10px"),
        ...shorthands.gap("10px"),
    },
});

export const RawDataManagement = () => {
    let [pageSize, setPageSize] = useState(10);
    let [page, setPage] = useState(null);
    let [totalPage, setTotalPage] = useState(0);
    let [tableHeight, setTableHeight] = useState(0);
    let [items, setItems] = useState([]);
    let [filter, setFilter] = useState(null);
    let { apiClient } = useContext(Context);
    let tableRef = useRef(null);
    let [refresh, setRefresh] = useState(0);

    const doRefresh = () => {
        setRefresh(refresh + 1);
    };

    const doDelete = async (id) => {
        if (apiClient) {
            try {
                // Note: This will need a proper API endpoint for raw data deletion
                console.warn("Raw data deletion not yet implemented in API");
                // await apiClient.deleteRawData(id);
                doRefresh();
            } catch (error) {
                console.error("Failed to delete raw data:", error);
            }
        }
    };

    const listItem = async () => {
        try {
            // For now, show placeholder message since raw data API isn't implemented
            console.warn("Raw data API not yet implemented, showing empty list");
            setItems([]);
            
            // TODO: Implement when raw data API is ready
            // const params = {};
            // if (filter) {
            //     params.search = filter;
            // }
            // const rawData = await apiClient.getRawData(null, params);
            // setItems(rawData || []);
        } catch (error) {
            console.error("Failed to load raw data:", error);
            setItems([]);
        }
    };

    useEffect(() => {
        if (apiClient) listItem();
    }, [apiClient, filter, refresh]);

    useEffect(() => {
        if (tableRef.current) {
            const getTableHeight = () => {
                let { height } = tableRef.current.getBoundingClientRect();
                setTableHeight(height);
            };
            getTableHeight();
            let handle = setInterval(getTableHeight, 1000);
            return () => clearInterval(handle);
        }
    }, [tableRef]);

    const columns = [
        createTableColumn({
            columnId: "name",
            renderHeaderCell: () => {
                return "文件名";
            },
            renderCell: (item) => {
                let name = item.name;
                // let name = item.name.substring(item.name.length - 10);
                // if (name.length < item.name.length) {
                //     name = `...${name}`;
                // }
                // return <div style={{ whiteSpace: "nowrap" }}>{name}</div>;
                return name;
            },
            compare: (a, b) => {
                if (a.id > b.id) return 1;
                if (a.id < b.id) return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "field",
            renderHeaderCell: () => {
                return "风场";
            },
            renderCell: (item) => {
                return item.leaf.turbine.field_item.name;
            },
            compare: (a, b) => {
                if (
                    a.item.leaf.turbine.field_item.name >
                    b.item.leaf.turbine.field_item.name
                )
                    return 1;
                if (
                    a.item.leaf.turbine.field_item.name <
                    b.item.leaf.turbine.field_item.name
                )
                    return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "turbine",
            renderHeaderCell: () => {
                return "风机";
            },
            renderCell: (item) => {
                return item.leaf.turbine.name;
            },
            compare: (a, b) => {
                if (a.item.leaf.turbine.name > b.item.leaf.turbine.name)
                    return 1;
                if (a.item.leaf.turbine.name < b.item.leaf.turbine.name)
                    return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "attach_id",
            renderHeaderCell: () => {
                return "挂载点";
            },
            renderCell: (item) => {
                return item.leaf.attach_id;
            },
            compare: (a, b) => {
                if (a.item.leaf.attach_id > b.item.leaf.attach_id) return 1;
                if (a.item.leaf.attach_id < b.item.leaf.attach_id) return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "uploaded_at",
            renderHeaderCell: () => {
                return "上传时间";
            },
            renderCell: (item) => {
                return new Date(item.uploaded_at).toLocaleString();
            },
            compare: (a, b) => {
                if (a.uploaded_at > b.uploaded_at) return 1;
                if (a.uploaded_at < b.uploaded_at) return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "uploaded_by",
            renderHeaderCell: () => {
                return "上传人员";
            },
            renderCell: (item) => {
                return item.uploaded_by.name;
            },
            compare: (a, b) => {
                if (a.uploaded_by.name > b.uploaded_by.name) return 1;
                if (a.uploaded_by.name < b.uploaded_by.name) return -1;
                return 0;
            },
        }),
        createTableColumn({
            columnId: "ops",
            renderHeaderCell: () => {
                return "操作";
            },
            renderCell: (item) => {
                return (
                    <Dialog>
                        <DialogTrigger disableButtonEnhancement>
                            <Link>删除</Link>
                        </DialogTrigger>
                        <DialogSurface>
                            <DialogBody>
                                <DialogTitle>确认删除</DialogTitle>
                                <DialogContent>
                                    是否删除{item.name}?
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => doDelete(item.id)}>
                                        删除
                                    </Button>
                                    <DialogTrigger>
                                        <Button appearance="primary">
                                            取消
                                        </Button>
                                    </DialogTrigger>
                                </DialogActions>
                            </DialogBody>
                        </DialogSurface>
                    </Dialog>
                );
            },
        }),
    ];

    const renderRow = ({ item, rowId }, style) => {
        return (
            <DataGridRow key={rowId} style={style}>
                {({ renderCell }) => (
                    <DataGridCell>{renderCell(item)}</DataGridCell>
                )}
            </DataGridRow>
        );
    };

    let styles = useStyles();
    return (
        <div className={styles.root}>
            <Input
                contentBefore={<SearchRegular />}
                onChange={(evt) => {
                    setFilter(evt.target.value);
                }}
                type="search"
                icon={<SearchRegular />}
                placeholder="按文件名、风机、上传人搜索..."
            />
            <div style={{ flex: 1, overflowY: "auto" }} ref={tableRef}>
                <DataGrid columns={columns} items={items} sortable>
                    <DataGridHeader>
                        <DataGridRow>
                            {({ renderHeaderCell }) => (
                                <DataGridHeaderCell>
                                    {renderHeaderCell()}
                                </DataGridHeaderCell>
                            )}
                        </DataGridRow>
                    </DataGridHeader>
                    <DataGridBody itemSize={42} height={tableHeight}>
                        {renderRow}
                    </DataGridBody>
                </DataGrid>
            </div>
        </div>
    );
};
